import {Alert, AlertDescription, AlertIcon, AlertTitle} from "@chakra-ui/react";
import {useTranslations} from "next-intl";
import {Link} from "../../../i18n/routing";

export default function ThanksForSubmission(
    {barName}: {barName: string}
) {
    const t = useTranslations("addbar")
    return (
        <Alert
            status='success'
            variant='subtle'
            flexDirection='column'
            alignItems='center'
            justifyContent='center'
            textAlign='center'
            height='200px'
        >
            <AlertIcon boxSize='40px' mr={0} />
            <AlertTitle mt={4} mb={1} fontSize='lg'>
                {t("thanks", {bar: barName})}
            </AlertTitle>
            <AlertDescription maxWidth='sm'>
                <Link href={{pathname: "/"}}>{t("go_back")}</Link>
            </AlertDescription>
        </Alert>
    )
}